import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="container py-16 text-center">
      <h1 className="section-title">Página Não Encontrada</h1>
      <p className="mb-8 text-lg">
        A página que você está procurando não existe ou foi movida.
      </p>
      <Link to="/" className="btn btn-primary">
        Voltar à Página Inicial
      </Link>
    </div>
  );
};

export default NotFound;
